import React from "react";
import { useAuthContext } from "../../../context/auth";

const DIFFICULTY_DISPLAY = [
  {
    label: "Easy",
    gradient: "linear-gradient(160deg, #E3FAFF 0%, #53CAF5 100%)",
  },
  {
    label: "Normal",
    gradient: "linear-gradient(160deg, #FFF5E0 0%, #F6B731 100%)",
  },
  {
    label: "Hard",
    gradient: "linear-gradient(160deg, #FFEBEB 0%, #FF5757 100%)",
  },
];

const HiluxDemo = () => {
  const { hiluxProgram } = useAuthContext();

  if (!hiluxProgram) return null;

  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-[100px]">
      <div className="flex flex-col items-center gap-[30px]">
        <img
          src="/hyrox-logo.png"
          alt="HYROX"
          className="w-[370px] h-[165px] object-contain"
        />
        <h1
          className="text-[70px] font-extrabold uppercase text-center gradient-text"
          style={{ textShadow: "0px 0px 30px rgba(0,0,0,0.25)" }}
        >
          Station challenge
        </h1>
      </div>

      <div className="flex gap-[40px] items-center">
        {DIFFICULTY_DISPLAY.map((option) => (
          <div
            key={option.label}
            className="w-[360px] py-[30px] px-[40px] rounded-[20px] text-[64px] font-extrabold text-[#020A1F] text-center capitalize"
            style={{ background: option.gradient }}
          >
            {option.label}
          </div>
        ))}
      </div>

      <div className="flex flex-col items-center gap-[30px] uppercase">
        <p className="text-[64px] font-bold text-white">
          {hiluxProgram.stations.length}개 스테이션
        </p>
        <p
          className="text-[50px] font-extrabold text-center gradient-text"
          style={{ textShadow: "0px 0px 30px rgba(0,0,0,0.25)" }}
        >
          최대한 빠르게 완주
        </p>
      </div>
    </div>
  );
};

export default HiluxDemo;
